import { TABLE_COLUMN } from '../constants';
import type { TaskListColumnSettings } from './types';

export const STORAGE_KEYS = {
	TASK_LIST: 'taskListColumnSettings',
	PROJECT_TASK_LIST: 'projectTaskListColumnSettings',
	SUBTASK_LIST: 'subtaskListColumnSettings',
} as const;

export const CONTEXT_AVAILABLE_COLUMNS = {
	TASK_LIST: [
		TABLE_COLUMN.Subitems,
		TABLE_COLUMN.Comments,
		TABLE_COLUMN.Status,
		TABLE_COLUMN.ActivityType,
		TABLE_COLUMN.Progress,
		TABLE_COLUMN.StartDate,
		TABLE_COLUMN.DueDate,
		TABLE_COLUMN.Budget,
		TABLE_COLUMN.RemainingBudget,
		TABLE_COLUMN.Planned,
		TABLE_COLUMN.Done,
		TABLE_COLUMN.Remaining,
	],
	PROJECT_TASK_LIST: [
		TABLE_COLUMN.Subitems,
		TABLE_COLUMN.Comments,
		TABLE_COLUMN.Status,
		TABLE_COLUMN.ActivityType,
		TABLE_COLUMN.Progress,
		TABLE_COLUMN.StartDate,
		TABLE_COLUMN.DueDate,
		TABLE_COLUMN.Budget,
		TABLE_COLUMN.RemainingBudget,
		TABLE_COLUMN.Planned,
		TABLE_COLUMN.Done,
		TABLE_COLUMN.Remaining,
	],
	SUBTASK_LIST: [
		TABLE_COLUMN.Comments,
		TABLE_COLUMN.Status,
		TABLE_COLUMN.ActivityType,
		TABLE_COLUMN.Progress,
		TABLE_COLUMN.StartDate,
		TABLE_COLUMN.DueDate,
		TABLE_COLUMN.Planned,
		TABLE_COLUMN.Done,
		TABLE_COLUMN.Remaining,
	],
} as const;

export const LOCKED_COLUMNS_START = [
	TABLE_COLUMN.Collapsible,
	TABLE_COLUMN.Assignee,
	TABLE_COLUMN.Actions,
	TABLE_COLUMN.Title,
] as const;

export const LOCKED_SORTABLE_COLUMNS_START = [
	TABLE_COLUMN.Assignee,
	TABLE_COLUMN.Title,
] as const;

export const LOCKED_COLUMNS_END = [TABLE_COLUMN.MarkDone] as const;

export const COLUMNS_HIDDEN_BY_DEFAULT = [
	TABLE_COLUMN.RemainingBudget,
] as const;

export const createDefaultColumnSettings = (
	availableColumns: readonly string[],
	hiddenByDefault: readonly string[] = []
): TaskListColumnSettings => {
	return availableColumns.map((id, index) => ({
		id,
		visible: !hiddenByDefault.includes(id),
		order: index,
	}));
};

export const STORAGE_KEY = STORAGE_KEYS.TASK_LIST;

export const SORTABLE_COLUMN_IDS = [
	TABLE_COLUMN.Subitems,
	TABLE_COLUMN.Comments,
	TABLE_COLUMN.Status,
	TABLE_COLUMN.ActivityType,
	TABLE_COLUMN.Progress,
	TABLE_COLUMN.StartDate,
	TABLE_COLUMN.DueDate,
	TABLE_COLUMN.Budget,
	TABLE_COLUMN.RemainingBudget,
	TABLE_COLUMN.Planned,
	TABLE_COLUMN.Done,
	TABLE_COLUMN.Remaining,
] as const;

export const DEFAULT_COLUMN_SETTINGS: TaskListColumnSettings =
	createDefaultColumnSettings(
		CONTEXT_AVAILABLE_COLUMNS.TASK_LIST,
		COLUMNS_HIDDEN_BY_DEFAULT
	);

export const SORTABLE_COLUMN_IDS_SET = new Set(SORTABLE_COLUMN_IDS);

export const LOCKED_COLUMNS_START_SET = new Set(LOCKED_COLUMNS_START);

export const LOCKED_COLUMNS_END_SET = new Set(LOCKED_COLUMNS_END);
